import type { OpenedConversation } from "@/api/agent-conversation";
import { getConfigServerOverview } from "@/api/config-server-stages";
import { getOrgStatuses, getOrgUnitContext } from "@/api/org-execution";
import { orgNodeFromContext } from "@/lib/org-unit-row";
import type { OrgTreeNode } from "@/lib/org-structure-tree";

/** A chave sozinha se repete entre níveis; só o run persistido ou a visão geral identifica o dono. */
export async function resolveOrgResumedOwner(
  projectId: string,
  target: OrgTreeNode,
  opened: OpenedConversation,
): Promise<OrgTreeNode | null> {
  if (!opened.resumed || target.lastRunId === opened.runId) return target;
  try {
    const statuses = await getOrgStatuses(projectId, [
      { item_type: target.levelCode, item_key: target.itemKey },
    ]);
    const current = statuses.items.find(
      (item) => item.key === `${target.levelCode}|${target.itemKey}`,
    );
    if (current?.last_run_id === opened.runId)
      return { ...target, lastRunId: opened.runId };
    const active = (await getConfigServerOverview(projectId))?.active_run;
    if (
      active?.kind !== "conversation" ||
      active.node !== "org_structure" ||
      active.id !== opened.runId ||
      !active.item_type ||
      !active.activity_code
    )
      return null;
    const context = await getOrgUnitContext(
      projectId,
      `${active.item_type}|${active.activity_code}`,
    );
    return { ...orgNodeFromContext(context), lastRunId: opened.runId };
  } catch {
    return null;
  }
}
export function sameOrgUnit(a: OrgTreeNode | null, b: OrgTreeNode): boolean {
  return !!a && a.levelCode === b.levelCode && a.itemKey === b.itemKey;
}
